import { ReactComponent as TripsIcon } from '../icons/main_menu/trips_1.svg';
import TripsPage from './TripsPage';

const exports = {
    Page: TripsPage,
    Icon: TripsIcon,
};
export default exports;
